export default "__VITE_ASSET__650405a6__"